import ScrollToTop from '@/shared/components/ScrollToTop';
import HomePage from '@/views/Home/HomePage';
import NotFoundPage from '@/views/NotFound/NotFoundPage';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import MonthlyInvoices from '@/views/Invoices/MonthlyInvoices';
import InvoiceDetails from '@/views/InvoiceDetails/InvoiceDetails';
import ItemSales from '@/views/ItemSales/ItemSales';

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/invoices" element={<MonthlyInvoices />} />
          <Route path='/invoice_details/:id' element={<InvoiceDetails />} />
          <Route path='/item_sales' element={<ItemSales />} />


        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
};
